import React from 'react';
import { Search, Settings, TrendingUp } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  icon: Search,
  title: 'Localiza',
  desc: 'Identificas tus fugas de capital usando nuestra autopsia financiera.'
}, {
  num: '2',
  icon: Settings,
  title: 'Automatiza',
  desc: 'Configuras el sistema para que tus primeros $75-$150 se inviertan antes de que puedas gastarlos.'
}, {
  num: '3',
  icon: TrendingUp,
  title: 'Monitorea',
  desc: 'Observas cómo tu dinero genera intereses mes tras mes sin esfuerzo adicional.'
}];
export function HowItWorks() {
  return <AnimatedSection className="py-24 bg-navy-800 relative px-4 sm:px-6 lg:px-8" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-20" data-id="element-58">
          Cómo funciona el sistema
        </h2>

        <div className="relative" data-id="element-59">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px bg-navy-600" data-id="element-60" />

          <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-61">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} className="flex flex-col items-center text-center relative" data-id="element-62">
                  <div className="w-24 h-24 rounded-full bg-navy-900 border-2 border-gold-400 flex items-center justify-center mb-6 relative shadow-[0_0_30px_rgba(212,175,55,0.15)]" data-id="element-63">
                    <span className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gold-400 text-navy-900 font-bold flex items-center justify-center text-sm" data-id="element-64">
                      {step.num}
                    </span>
                    <Icon className="w-10 h-10 text-gold-400" data-id="element-65" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4" data-id="element-66">
                    {step.title}
                  </h3>
                  <p className="text-slate-400 text-lg leading-relaxed" data-id="element-67">
                    {step.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-68" />
    </AnimatedSection>;
}